import { TextInput } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

export interface ILivestockFormProps extends IForm {}

const LivestockForm = (props: ILivestockFormProps) => {
  const { values, onCallbackChange, mode } = props;
  const isReadOnly = mode === 'view';
  return (
    <TextInput label="Notes" multiline isReadOnly={isReadOnly} value={values?.notes ?? ''} onChange={onCallbackChange('notes')} />
  );
};

export default LivestockForm;
